<template>
    <div class="brandsBox">
        <a v-for="(item, index) in brands" :key="index" :href="item.url" class="brandsBox__item">
            <img :src="item.desktopImage" :alt="item.title" class="brandsBox__images" loading="lazy" />
        </a>
    </div>
</template>

<script lang="ts">
export default {
    props: {
        brands: {
            type: Array as PropType<any[]>,
            default: () => {},
        },
    },

    computed: {},
}
</script>

<style lang="scss" scoped>
/*
Structure:
    .brandsBox
        .brandsBox__item
            .brandsBox__images
*/

.brandsBox {
    display: flex;
    box-shadow: $box-shadow;
    border-radius: 10px;
    justify-content: space-evenly;
    align-items: center;
    margin: 0px auto 50px;
    max-width: $max-width-container-inside;
    padding: 10px 0;
    flex-wrap: wrap;
}

.brandsBox__item {
    max-width: 90px;
    margin: 10px;
}

.brandsBox__images {
    max-height: 100%;
    max-width: 100%;
}
</style>
